<template>
  <div class="paymentStatus">
    <div v-if="parseInt(subscInfo.active) && paymentMsg" class="paymentStatus__msg">{{ paymentMsg }}</div>
    <div v-if="/^(1|3)$/.test(subscInfo.status)" class="paymentStatus__title">サブスクリプションのお支払い方法</div>
    <Attention v-if="attentionMsg" class="paymentStatus__attention" :text="attentionMsg"/>
    <template v-if="subscInfo.payee === 'SBPS-credit' && /^(1|3)$/.test(subscInfo.status)">
      <CardInfo
        class="paymentStatus__info"
        v-if="isRegistered"
        :card-number="card.number"
        :card-expiration="card.expiration"
      />
    </template>
    <template v-else-if="subscInfo.payee === 'AmazonPay' && /^(1|3)$/.test(subscInfo.status)">
      <div class="paymentStatus__amazon">Amazon Pay</div>
      <template v-if="isRegistered">
        <div class="paymentStatus__title">ご登録済みお支払い情報</div>
        <CardInfo 
          class="paymentStatus__info"
          :card-number="card.number"
          :card-expiration="card.expiration"
        />
      </template>
    </template>
    <template v-else-if="isRegistered">
      <CardInfo 
        class="paymentStatus__info"
        :card-number="card.number"
        :card-expiration="card.expiration"
      />
    </template>
    <NextButton
      class="paymentStatus__button"
      style="justify-content: space-between;"
      :label="buttonLabel"
      @clicked="registCard"
    />
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex'
import { convertKanjiYMD } from '@/utils/filters'
import * as type from '@/utvStore/store/mutation-types'
import { PAYEE } from '@/CONSTS/'
import moment from 'moment'
import fetchAccountData from '@/utils/fetchAccountData'
import Attention from './common/Attention'
import NextButton from './common/NextButton'
import CardInfo from './partials/CardInfo'

export default {
  name: 'PaymentStatus',
  components:{
    Attention,
    NextButton,
    CardInfo
  },
  data() {
    return {
      isRegistered: false,
      attentionMsg: '',
    }
  },
  props: {
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      card: state => state.payment.card,
      userInfo: state => state.account.user,
      subscInfo: state => state.account.subscription
    }),
    ...mapGetters(['isLoggedIn']),

    buttonLabel(){
      return this.isRegistered ? 'クレジットカード情報を変更する' : 'クレジットカード情報を登録する'
    },
    paymentMsg(){
      switch(parseInt(this.subscInfo.status)){
        case 2:
          //サブスク停止中
          this.attentionMsg = `${convertKanjiYMD(this.subscInfo.next_payment_due)}のお引き落としができなかったため、サブスクリプションが停止しています。 再開するには<a href="/subsc/rejoin" style="color:#FF7497;">こちら</a>からお手続きをお願いします。`
          return ''
          break
        case 3:
          //サブスク解約申し込みユーザ
          const time = parseInt(this.userInfo.subscription.current_peirod_to) * 1000
          const peirodTo = window.moment(time).format('YYYY年M月D日')
          return `${peirodTo}までご利用いただけます。`
          break
        default:
          return `次回請求日は${convertKanjiYMD(this.subscInfo.next_payment_due)}です。`
      }
    }
  },
  created() {
    if (this.isLoggedIn) this.getPaymentInfo()
  },
  methods: {
    getPaymentInfo() {
      if (this.isLoggedIn && this.accessToken) {
        //カード情報取得
        this.$store.dispatch(type.GET_PAYMENT_INFO, { access_token: this.accessToken })
        .then(()=> {
          this.isRegistered = true
          this.attentionCardExpiration()
          })
        .catch((err)=>console.log('card-unregistered!'))
      }
    },
    registCard(){
      location.href ='/user/account/payment'
    },
    attentionCardExpiration(){
      // カード有効期限をチェックし１ヶ月前になったら警告を表示する
      const cardExpiration = `${this.card.expiration.substr(0, 4)}-${this.card.expiration.substr(4, 6)}`
      const diffMonth = moment(cardExpiration).diff(moment(), 'month')
      if(diffMonth < 1) this.attentionMsg = 'まもなくクレジットカード有効期限が切れます。有効期限を更新してください。'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/commons/commonVariables.scss";
.paymentStatus{
  color: $col_base_black;
  max-width: 580px;
  margin: auto;
  border-bottom: solid 1px $col_temp_gray3;

  &__attention{
    margin: 35px 20px 20px;
  }
  &__msg{
    width: 100%;
    height: 35px;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.3);
    background: rgba(255, 255, 255, 0.4);
    font-size: 12px;
    line-height: 35px;
    padding: 0 20px;
  }
  &__title {
    font-size: 12px;
    line-height: 18px;
    background: linear-gradient(81.44deg, rgba(#FF7497, 0.07) 21.4%, rgba(#CB8BFF, 0.07) 76.64%);
    padding: 9px 20px 8px;
  }
  &__amazon {
    font-size: 13px;
    line-height: 19px;
    padding: 15px 20px;
    + .paymentStatus__button {
      border-top: solid 1px $col_temp_gray3;
    }
  }
  &__info{
    border-bottom: solid 1px $col_temp_gray3;
  }
  &__button{
    padding: 13px 20px 12px;
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/PaymentStatus.vue